const types = {


  GET_LIST_BLOG:'blog/GET_LIST_BLOG',
  GET_ITEM_BLOG:'blog/GET_ITEM_BLOG',

};

export default types;
